export const queryKeys = {
  TASK_FILTER_CRM: 'TASK_FILTER_CRM',
  TASK_FILTER_CALENDAR: 'TASK_FILTER_CALENDAR',
  TABLE_VIEW_TASK: 'TABLE_VIEW_TASK',
  TASK_EMPLOYEE: 'TASK_EMPLOYEE',
  TASK_TYPE: 'TASK_TYPE',
  TASK_ACTION: 'TASK_ACTION'
};
